import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useUpdateUserProfile = () => {
  const queryClient = useQueryClient();
  const { mutateAsync: mutateAsyncUpdateUserProfile, isPending } = useMutation('updateUserProfile', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: ['user-profile'] });
      toast.success(res.message);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return { mutateAsyncUpdateUserProfile, isPending };
};

export default useUpdateUserProfile;
